import {
  POST,
  GET
} from '@/axios/axios'

export const services = {
  findApiErrorCodeDictList: (param) => {   // 错误码列表
    return GET("/backend/errorCode/findApiErrorCodeDictList", param);
  },
  updateApiErrorCodeDict: (param) => {   // 修改完善录入三方错误码
    return POST("/backend/errorCode/updateApiErrorCodeDict", param);
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/errorCode.js